<div [id]="'symptom-map-' + symptomMapId" class="symptom-map"
     [ngClass]="{
     'symptom-map--full-screen': isFullScreen,
     'symptom-map--hidden': svgPanZoomInstance == null,
     'symptom-map--no-legends': !showLegends && svgPanZoomInstance ,
     'view-mode': viewMode,
     'edit-mode': editMode || openProposalDiagnosis
     }">
    <div *ngIf="collapseDiagnoses == false" class="backdrop"></div>

    <div *ngIf="showGestureHint" class="backdrop map-guide">
        <p class="map-guide__text">{{ 'Use 2 fingers to pan' | translate }}
            </p>
    </div>

    <div *ngIf="selectedCurrentDate === QUESTIONNAIRE_IN_PROGRESS" class="backdrop map-guide">
        <p class="map-guide__text">
            {{ symptomMapId === 'SE' ? ('No data yet. Please send out self report to patient.' | translate) : ('No data yet. Please finish self report.' | translate) }}
        </p>
    </div>

    <!-- Remove in future -->
    <div class="symptom-map-menu panel-header hidden" *ngIf="!(isFullScreen && (editMode || openProposalDiagnosis))">
        <ul class="list-inline" >
            <li class="list-inline-item mr-r--lg">
                <button *ngIf="(comparisonDates.length >= 1 && !isComparisonViewMode && !openProposalDiagnosis)" type="button" class="btn btn-primary btn-radius panel-header-button" (click)="enableComparisonMode(true);">
                    <span>{{ 'Show comparison' | translate }}</span>
                </button>
                <button type="button" class="btn clear-comparison panel-header-button" *ngIf="comparisonDates.length >= 1 && isComparisonViewMode">
                    <span class="clear-comparison__text">{{ 'Hide comparison' | translate }}</span>
                    <i class="pull-right fas fa-times-circle clear-comparison__icon" (click)="enableComparisonMode(false);this.showGraphic = false;"></i>
                </button>
            </li>
            <li class="list-inline-item mr-r--lg">
                <button *ngIf="canEdit && !isComparisonViewMode" type="button" class="btn btn-primary btn-radius panel-header-button edit-symptoms" (click)="enableEdit(symptomMapId);">
                    <ng-container *ngIf="symptomMapId === 'SE'">
                        {{ 'Edit copy in Clinic Validation' | translate }}
                    </ng-container>
                    <ng-container *ngIf="symptomMapId !== 'SE'">
                        <ng-container *ngIf="!latestQuestionnaire.archived">
                            {{ 'Edit copy of Self report' | translate }}
                        </ng-container>
                        <ng-container *ngIf="latestQuestionnaire.archived">
                            {{ 'Edit Symptoms' | translate }}
                        </ng-container>
                    </ng-container>
                </button>
            </li>
            <li class="list-inline-item comparison-dates" *ngIf="isComparisonViewMode">
                <div class="btn-group dropdown" [ngClass]="{ 'dropdown--selected': selectedComparisonDate }" dropdown #comparesDateDropdown="bs-dropdown">
                    <button dropdownToggle type="button" class="btn btn-primary dropdown-toggle" [ngClass]="{ 'dropdown-toggle--selected': selectedComparisonDate, 'dropdown-toggle--active' : comparisonDates.length > 0 && !isCompared}">
                        <span *ngIf="!selectedComparisonDate; else comparisonDateTemplate">
                            <span class="dropdown-toggle__text">
                                {{ selectedComparisonDate ? selectedComparisonDate : symptomMapId === 'SE' ? ('Compare Self Evaluation' | translate) : ('Compare Diagnostic Interview' | translate) }}
                            </span>
                            <span class="caret"></span>
                        </span>
                        <ng-template #comparisonDateTemplate>
                            <div class = "dropdown-toggle--select__text">
                                <span class="type__update-date">
                                        {{ 'Comparison date' | translate }} {{ selectedComparisonDate }}
                                        <span class="dropdown__delete">
                                            <i class="fas fa-chevron-down"></i>
                                        </span>
                                </span>
                            </div>
                        </ng-template>
                    </button>
                    <ul *dropdownMenu class="dropdown-menu dropdown-menu-left" role="menu">
                        <li role="menulabel">
                            <span>{{ symptomMapId === 'SE' ? ('Self Evaluation' | translate) : ('Diagnostic Interview' | translate) }} {{ 'from' | translate }}
                            </span>
                        </li>
                        <div  *ngIf="comparisonDates.length > 0; else noComparisonDateTemplate">
                            <div *ngFor="let comparisonDate of comparisonDates; let i = index">
                                <li role="menuitem">
                                    <div class="dropdown-item" (click)="selectedComparisonId = comparisonDate.id; loadSymptomMap(); isComparisonViewMode = true;">
                                        <span>
                                            <div class="dropdown-item__description">
                                                    {{ comparisonDate.date }}
                                            </div>
                                        </span>
                                    </div>
                                    <i *ngIf="selectedComparisonId === comparisonDate.id" class="fas fa-times fa-lg dropdown-item__remove" aria-hidden="true"
                                        (click)="enableComparisonMode(false)"></i>
                                </li>
                            </div>
                        </div>
                        <ng-template #noComparisonDateTemplate>
                            <li role="menuitem">
                                <div class="dropdown-item">
                                    <span>
                                        <div class="dropdown-item__description">
                                            {{ symptomMapId === 'SE' ? ('No other Self Evaluation available' | translate) : ('No other Diagnostic Interview available'
                                            | translate) }}
                                        </div>
                                    </span>
                                </div>
                            </li>
                        </ng-template>
                    </ul>
                </div>
            </li>
            <div class="dropdown btn-group btn-export-group control center btn-export-group--right">
                <div *ngIf="showDropdown" class="overlay" (click)="showDropdown=false;"></div>
                <button dropdownToggle type="button" class="btn btn-primary dropdown-toggle {{ menuDirection }}" [ngClass]="{'open': showDropdown}" id="symptom-map-menu-btn-{{symptomMapId}}" (click)="getPosition();showMenuDropdown();">
                    <span>{{ 'Menu' | translate }}</span>
                    <span class="caret"></span>
                </button>
                <ul [class.invisibility]="!showDropdown" id="symptom-map-menu-content-{{symptomMapId}}" class="dropdown-menu dropdown-menu-right" role="menu" [ngStyle]="dropdownPosition" (click)="this.showDropdown = !this.showDropdown;">
                    <li role="menulabel">
                        <span>{{ 'View' | translate }}</span>
                    </li>
                    <li role="menuitem" [hidden]="showGraphic">
                        <div class="dropdown-item" (click)="toggleFullScreen(false)">
                            <i class="fas" [ngClass]="isFullScreen ? ' fa-compress-arrows-alt' : ' fa-expand-arrows-alt'"></i>
                            <span>
                                {{ (isFullScreen ? 'Minimize' : 'Maximize') | translate }}
                            </span>
                        </div>
                    </li>
                    <li role="menuitem">
                        <div class="dropdown-item" (click)="showLegends = !showLegends">
                            <i class="fas fa-tags" [ngClass]="{ 'hide': showLegends }"></i>
                            <span>
                                    {{ (showLegends ? 'Hide legends' : 'Show legends') | translate }}
                            </span>
                        </div>
                    </li>
                    <li role="menuitem" (click)="toggleUnselectedDomains()" [hidden]="showGraphic">
                        <div class="dropdown-item">
                            <i class="fas" [ngClass]="allDomainsAreShown ? 'fa-eye-slash' : 'fa-eye'"></i>
                            <span>
                                    {{ (allDomainsAreShown ? 'Hide unselected Domains' : 'Show all Domains') | translate }}
                            </span>
                        </div>
                    </li>
                    <li class="divider dropdown-divider"></li>
                    <li role="menulabel">
                        <span>{{ 'Export' | translate }}</span>
                    </li>
                    <li role="menuitem" [hidden]="showGraphic">
                        <div class="dropdown-item" (click)="exportPDF()">
                            <i class="fas fa-print"></i>
                            <span>{{ 'PDF - A3' | translate }}</span>
                        </div>
                    </li>
                    <li role="menuitem" [hidden]="showGraphic">
                        <div class="dropdown-item" (click)="callExport()">
                            <i class="fas fa-print"></i>
                            <span>{{ 'Export Expert' | translate }}</span>
                        </div>
                    </li>
                    <li role="menuitem" [hidden]="showGraphic">
                        <div class="dropdown-item" (click)="exportPNG()">
                            <i class="far fa-file-alt"></i>
                            <span>{{ 'PNG - A3' | translate }}</span>
                        </div>
                    </li>
                    <li role="menuitem" [hidden]="!isComparisonViewMode || !showGraphic">
                        <div class="dropdown-item" (click)="exportGraphics()">
                            <i class="far fa-file-alt"></i>
                            <span>{{ 'Graphics' | translate }}</span>
                        </div>
                    </li>
                    <li class="divider dropdown-divider"></li>
                    <li role="menuitem">
                        <div class="dropdown-item dropdown-item-questionare help-btn" (click)="openPopover($event)">
                            <app-popover
                                [templateType]="symptomMapId === 'DI' ? HELP_DI_MAP : HELP_SE_MAP"
                                iconClass="icon--questionare blue-primary"
                                margin="unset"
                                fontSize="1.5rem"
                                [styles]="styles"
                                placement="left"
                                container="body"
                                containerClass="symptom-map-menu-help">
                            </app-popover>
                            <span>
                                {{ 'Operation Manual' | translate }}
                            </span>
                        </div>
                    </li>
                </ul>
            </div>
        </ul>
    </div>

    <div *ngIf="isFullScreen && (editMode || openProposalDiagnosis)" class="box-shadow edit-mode-box hidden" (click)="openProposalDiagnosis ? closeProposalDiagnosis(false) : closeInteractive(false)">
        <i class="edit-mode-btn fas fa-long-arrow-left"></i>
        <span class="patient-name">
            <span *ngIf="patientSurname != null">
                {{ patientSurname }},
            </span>
            <span *ngIf="patientName != null">
                {{ patientName }}
            </span>
        </span>
    </div>

    <ul class="symptom-map-menu legend-top" *ngIf="isComparisonViewMode && !showGraphic">
        <li class="list-inline-item list-title">
            <span class="list-inline-item__label font-weight-bold">{{ 'Focus' | translate }}</span>
        </li>
        <li class="list-inline-item btn-icon btn-icon--left list-inline-item--focus" [class.active]="selectedComparisonType == 'none'" (click)="selectedComparisonType = 'none'">
            <span class="list-inline-item__label focus">{{ 'No Focus' | translate }}</span>
        </li>
        <li class="list-inline-item btn-icon btn-icon--left list-inline-item--reduced" [class.active]="selectedComparisonType == 'reduced'" (click)="selectedComparisonType = 'reduced'">
            <span class="list-inline-item__number reduced">{{ comparisonData.positive_change.length}}</span>
            <span class="list-inline-item__label">{{ 'Reduced' | translate }}</span>
        </li>
        <li class="list-inline-item btn-icon btn-icon--left mr-r--n list-inline-item--increased" [class.hovered]="hoveredIncreased" [class.active]="selectedComparisonType == 'increased'" (click)="selectedComparisonType = 'increased'">
            <span class="list-inline-item__number increased">{{ comparisonData.negative_change.length}}</span>
            <span class="list-inline-item__label">{{ 'Increased' | translate }}</span>
        </li>
        <li class="list-inline-item btn-icon btn-icon--left list-inline-item--newly" (mouseover)="hoveredIncreased=true" (mouseout)="hoveredIncreased=false" [class.active]="selectedComparisonType == 'increased'" (click)="selectedComparisonType = 'increased'">
            <span class="list-inline-item__number newly-occurred">{{ comparisonData.new_appearance.length}}</span>
            <span class="list-inline-item__label newly-occurred">{{ 'Newly occurred' | translate }}</span>
        </li>
        <li class="list-inline-item btn-icon btn-icon--left list-inline-item--unchanged mr-r--n" [class.active]="selectedComparisonType == 'unchanged'" (click)="selectedComparisonType = 'unchanged'">
            <span class="list-inline-item__number unchanged">{{ comparisonData.no_change.length}}</span>
            <span class="list-inline-item__label unchanged">{{ 'Unchanged' | translate }}</span>
        </li>
        <li class="list-inline-item btn-icon list-inline-item--last" [hidden]="isFullScreen" (click)="showGraphic = true;">
            <span class="list-inline-item--last__label unchanged">{{ 'Graphical comparison' | translate }}</span>
        </li>
    </ul>

    <button type="button" class="btn close-graphic" *ngIf="showGraphic">
        <span class="close-graphic__text">{{ 'Hide graphic' | translate }}</span>
        <i class="pull-right fas fa-times-circle close-graphic__icon" (click)="showGraphic = false;"></i>
    </button>

    <div #symptomMapSvg [id]="'symptom-map-svg-content-' + symptomMapId"
         class="symptom-map-svg-content user-select-none {{selectedComparisonType ? 'focus-mode ' + selectedComparisonType : ''}}"
         [class.comparison]="selectedComparisonId !== 0"
         [class.disabled]="openProposalDiagnosis"
         [ngClass]="{
                    'hidden-unselected-se-domains': !allDomainsAreShown && symptomMapId === 'SE',
                    'hidden-unselected-di-domains': !allDomainsAreShown && symptomMapId === 'DI',
                    'interactive-mode': editMode,
                    'proposal-mode': openProposalDiagnosis,
                    'view-mode': !editMode,
                    'opacity-0': showGraphic,
                    'dragging': focusingOnMap
                    }"
         ng-bind-html="svg_data"
         (mousedown)="focusingOnMap = true"
         (mousemove)="dragging =  focusingOnMap ? true : false"
         (mouseup)="focusingOnMap= false; interactiveMap($event)"
         (touchstart)="onMapTouchStart($event)"
         (touchmove)="onMapTouchMove($event)"
         (wheel)="onMouseWheel($event)">

    </div>
    <div class="spinner-wrapper spinner-wrapper--partial bg-dark map-spinner" [hidden]="!updatingInteractiveMap">
        <div class="spinner">
            <div class="spinner__loading"><i></i><i></i></div>
        </div>
    </div>

    <div id="graphic-comparison" *ngIf="showGraphic">
        <div class="col-xs-4 graphic-item" *ngFor="let domain of graphicData">
            <div class="graphic-item__data">
                <div class="symptom last-child fal">
                    <span class="symptom__name"></span>
                    <span class="symptom__circle"></span>
                </div>
                <div *ngFor="let item of domain" class="symptom">
                    <span class="symptom__name">{{item['symptom_name'] | replace : '#' : ' '}}</span>
                    <span class="symptom__circle {{item['type']}} step-{{item['step']}} {{item['status']}}">
                        <span *ngFor="let n of numSequence(item['step']); let i = index;" class="seperate"></span>
                    </span>
                </div>
                <div class="symptom first-child">
                    <span class="symptom__name"></span>
                    <span class="symptom__circle"></span>
                </div>
            </div>
            <div class="graphic-item__name">
                <h2>{{ domain[0]['domain_name'] }}</h2>
            </div>
        </div>
    </div>

    <interactive-map-component #interactiveMapComponent *ngIf="selectedCurrentId && initialSymptomMap"
                               [class.hidden]="openProposalDiagnosis"
                               [isCollapsed]="!openInteractive"
                               [activeItemId]="activeItemId"
                               [activeItem]="activeItem"
                               [nodeClassList]="(symptomNode && openComparison && activeItem.type === 'comparison')? symptomNode.classList : []"
                               [symptomMapId]="selectedCurrentId"
                               [isDisabled]="!canEdit"
                               (updateMap)="updateInteractiveMap($event)"
                               (setMapDisable)="setMapDisable($event)"
                               (highlightDomain)="editMode ? setActiveDomain($event) : false"
                               (highlightSymptom)="editMode ? setFocusState($event) : false"
                               (closeInteractive)="closeInteractive($event)"
                               (openProposalDiagnosis)="openProposalMap()"
                               (showErrorModal)="openAlertModal($event)"
                               [isFullScreen]="isFullScreen"
                               [isComparisonViewMode]="openComparison"
                               [showLegends]="showLegends"
                               [isViewOnly]="viewMode">
    </interactive-map-component>

    <comparison-map-component
                                *ngIf="openComparison"
                                #comparisonMap
                                [symptomMapType]="symptomMapId"
                                [selectedCurrentId]="selectedCurrentId"
                                [selectedCurrentDate]="selectedCurrentDate"
                                [comparisonDates]="completedDates"
                                [isCollapsed]="!openComparison"
                                [graphicData]="graphicData"
                                [comparisonData]="comparisonData"
                                (drawMap)="drawComparisonMap($event)"
                                (filterComparison)="applyComparison($event)">
    </comparison-map-component>

    <proposal-diagnosis-component *ngIf="selectedCurrentId && openProposalDiagnosis"
                                  #diagnosisComponent
                                  [isCollapsed]="!openProposalDiagnosis"
                                  [nodeClassList]="(symptomNode && openComparison && activeItem.type === 'comparison')? symptomNode.classList : []"
                                  [diagnosesProposal]="patientService.proposalData"
                                  [mapData]="interactiveMapComponent ? interactiveMapComponent.mapData : []"
                                  [patientId]="patientId"
                                  [isDisabled]="!canEdit"
                                  [selectedCurrentQuestionnaire]="selectedCurrentQuestionnaire"
                                  (closeProposalDiagnosis)="closeProposalDiagnosis()"
                                  [symptomMapId]="selectedCurrentId"
                                  (updateMap)="updateInteractiveMap($event)"
                                  (setMapDisable)="setMapDisable($event)"
                                  (highlightDomain)="editMode ? setActiveDomain($event) : false"
                                  (highlightSymptom)="(editMode || openProposalDiagnosis) ? setFocusState($event) : false"
                                  (closeInteractive)="closeInteractive($event)"
                                  (showErrorModal)="openAlertModal($event)"
                                  [isFullScreen]="isFullScreen"
                                  (highlight)="highlightProposalDiagnosis($event)">
    </proposal-diagnosis-component>

    <div *ngIf="svgPanZoomInstance" class="resize-menu">
        <button class="btn-link" (click)="zoomIn(svgPanZoomInstance)" [ngClass]="zoomLevel === 3 ? ' btn-link--disabled' : ''">
            <i class="fas fa-plus"></i>
        </button>
        <span class="divider"></span>
        <button class="btn-link" (click)="zoomOut(svgPanZoomInstance)" [ngClass]="zoomLevel === 1 ? ' btn-link--disabled' : ''">
            <i class="fas fa-minus"></i>
        </button>
    </div>

    <div class="legend-menu">
        <button class="btn-link" (click)="showLegends = !showLegends">
            <i class="far fa-cog"></i>
        </button>
    </div>
    <div class="legends" [ngClass]="{ 'hidden': !showLegends }">
        <ul class="d-inline-block list-inline" [ngClass]="{ 'full-height': !openProposalDiagnosis && !openComparison }">
            <li class="list-inline-item btn-icon btn-icon--left">
                <span class="legends__icon legends__icon--none"></span> {{ 'None' | translate }}
            </li>
            <li class="list-inline-item btn-icon btn-icon--left">
                <span class="legends__icon legends__icon--mild"></span> {{ 'Mild' | translate }}
            </li>
            <li class="list-inline-item btn-icon btn-icon--left">
                <span class="legends__icon legends__icon--moderate"></span> {{ 'moderate' | translate }}
            </li>
            <li class="list-inline-item btn-icon btn-icon--left">
                <span class="legends__icon legends__icon--severe"></span> {{ 'severe' | translate }}
            </li>
            <li class="list-inline-item btn-icon btn-icon--left">
                <span class="legends__icon legends__icon--anamnestic-only"></span> {{ 'Anamnestic only' | translate }}
            </li>
            <li class="list-inline-item btn-icon btn-icon--left btn-icon--show-domain" (click)="toggleUnselectedDomains()">
                <i class="fas" [ngClass]="allDomainsAreShown ? 'fa-eye-slash' : 'fa-eye'"></i>
                <span class="btn-text">
                    {{ (allDomainsAreShown ? 'Hide unselected Domains' : 'Show all Domains') | translate }}
                </span>
            </li>
        </ul>
        <div *ngIf="openProposalDiagnosis">
            <ul class="d-inline-block list-inline">
                <li class="list-inline-item btn-icon btn-icon--left list-inline-item--criteria">
                    <span class="legends__icon legends__icon--expert"></span> {{ 'Expert items' | translate }}
                </li>
                <li class="list-inline-item btn-icon btn-icon--left list-inline-item--criteria">
                    <span class="legends__icon legends__icon--match"></span> {{ 'Criteria matched' | translate }}
                </li>
                <li class="list-inline-item btn-icon btn-icon--left list-inline-item--criteria">
                    <span class="legends__icon legends__icon--not-match"></span> {{ "Criteria not matched" | translate }}
                </li>
            </ul>
        </div>
        <div *ngIf="openComparison">
            <ul class="d-inline-block list-inline">
                <li class="list-inline-item btn-icon btn-icon--left">
                    <span class="legends__icon legends__icon--increased"></span> {{ 'Increased' | translate }}
                </li>
                <li class="list-inline-item btn-icon btn-icon--left">
                    <span class="legends__icon legends__icon--newly-occurred"></span> {{ 'Newly occurred' | translate }}
                </li>
                <li class="list-inline-item btn-icon btn-icon--left">
                    <span class="legends__icon legends__icon--reduced"></span> {{ 'Reduced' | translate }}
                </li>
                <li class="list-inline-item btn-icon btn-icon--left">
                    <span class="legends__icon legends__icon--hide-on-sr-map"></span> {{ 'in Clinical Rating only' | translate }}
                </li>
                <li class="list-inline-item btn-icon btn-icon--left">
                    <span class="legends__icon legends__icon--hide-on-di-map"></span> {{ 'CR vs. CR' | translate }}
                </li>
            </ul>
        </div>
    </div>

    <div class="action-menu">
        <div class="btn-group" dropdown>
            <button dropdownToggle type="button" class="btn dropdown-toggle">
                <span class="dropdown-toggle__text">
                    {{ selectedCurrentDate | translate }}
                </span>
            </button>
            <ul *dropdownMenu class="dropdown-menu dropdown-menu-left" role="menu">
                <div *ngFor="let date of currentDates; let i = index">
                    <li role="menuitem">
                        <div class="dropdown-item dropdown-item--date-selection" [class.disabled]="date.id === selectedCurrentId" (click)="onDateSelect(date)">
                            <span>
                                <div class="dropdown-item__description">
                                    {{ date.date }}
                                </div>
                            </span>
                        </div>
                    </li>
                </div>
            </ul>
        </div>
        <div class="btn-group" dropdown [isDisabled]="selectedCurrentDate === QUESTIONNAIRE_IN_PROGRESS">
            <button dropdownToggle type="button" class="btn icon">
                <i class="action-menu__icon profile-action-btn"></i>
            </button>
            <ul *dropdownMenu class="dropdown-menu dropdown-menu-left" role="menu">
                <li role="menuitem">
                    <div class="dropdown-item" (click)="exportPDF()">
                        <i class="fas fa-print"></i>
                        <span class="btn-text">{{ 'PDF - A3' | translate }}</span>
                    </div>
                </li>
                <li role="menuitem">
                    <div class="dropdown-item" (click)="callExport()">
                        <i class="fas fa-print"></i>
                        <span class="btn-text">{{ 'Export Expert' | translate }}</span>
                    </div>
                </li>
                <li role="menuitem" >
                    <div class="dropdown-item" (click)="exportPNG()">
                        <i class="far fa-file-alt"></i>
                        <span class="btn-text">{{ 'PNG - A3' | translate }}</span>
                    </div>
                </li>
                <li role="menuitem" [hidden]="!openComparison">
                    <div class="dropdown-item" (click)="exportGraphics()">
                        <i class="far fa-file-alt"></i>
                        <span class="btn-text">{{ 'Graphics' | translate }}</span>
                    </div>
                </li>
            </ul>
        </div>
        <div class="btn-group" *ngIf="!openProposalDiagnosis && (comparisonDates.length >= 1 || (comparisonDates.length === 0 && completedDates.length === 1 && completedDates[0]['sr_id'] && completedDates[0]['di_id']))">
            <button type="button" class="btn icon" (click)="openCompareMode()" [disabled]="selectedCurrentDate === QUESTIONNAIRE_IN_PROGRESS">
                <i class="action-menu__icon profile-compare-btn" [class.active]="openComparison"></i>
            </button>
        </div>
    </div>

    <div *ngIf="!isLoading">
        <div class="no-map">
            <div class="symptom-map-menu panel-header" *ngIf="canEdit">
                <ul class="list-inline">
                    <button type="button" class="btn btn-primary btn-radius panel-header-button" (click)="enableEdit(symptomMapId);">
                        <ng-container *ngIf="symptomMapId === 'SE'">
                            {{ 'Edit copy in Clinic Validation' | translate }}
                        </ng-container>
                        <ng-container *ngIf="symptomMapId !== 'SE'">
                            <ng-container *ngIf="!latestQuestionnaire.archived">
                                {{ 'Edit copy of Self report' | translate }}
                            </ng-container>
                            <ng-container *ngIf="latestQuestionnaire.archived">
                                {{ 'Edit' | translate }}
                            </ng-container>
                        </ng-container>
                    </button>
                </ul>
            </div>
            <div class="text-sm-center">
                {{ 'Symptom map unavailable' | translate }}
                <button *ngIf="false" type="button" class="btn btn-link btn-link--primary" (click)="openCreateQuestionnaire()">{{ 'Add new Questionnaires?' | translate }}</button>
            </div>
        </div>
    </div>
</div>


<!-- DIRECTIVE : EXPORT SYMPTOM MAP FOR PATIENT -->
<div class="hidden-xs-up">
    <form id="frmExport" action="{{authService.baseUrl}}patient/export-symptom/{{patientId}}" method="POST">
        <textarea id="symptom-content" name="symptomMap">
                </textarea>
        <textarea id="symptom-legends" name="symptomLegends">
                </textarea>
        <textarea id="clinic-info" name="avatar">
                </textarea>
        <div id="frm-DI-attributes">
        </div>
    </form>
    <div id="map-content-DI" class=""></div>
    <div id="map-content-SE" class="{{selectedComparisonType ? 'focus-mode ' + selectedComparisonType : ''}}"></div>
</div>
<div class="hidden-xs-up">
    <form id="frmExportLatest" action="{{authService.baseUrl}}patient/export-symptom/{{patientId}}" method="POST">
        <textarea id="symptom-content-latest" name="symptomMap">
                </textarea>
        <textarea id="symptom-legends-latest" name="symptomLegends">
                </textarea>
        <textarea id="clinic-info-latest" name="avatar">
                </textarea>
        <div id="frm-DI-attributes-latest">
        </div>
    </form>
    <div id="map-content-DI-lastest"></div>
    <div id="map-content-SE-lastest"></div>
</div>
<div class="hidden-xs-up">
    <form id="graphicExport" action="{{authService.baseUrl}}patient/export-graphic-comparison" method="POST">
    </form>
</div>
<div>
    <form id="expertExport" action="{{authService.baseUrl}}patient/export-expert-symptom" method="POST">
    </form>
    <div id="map-content-expert-item" *ngIf="showExpertsElement">
        <ng-container *ngFor="let domain of expertDatas">
            <div class="item" *ngIf="domain.is_show_on_task_list">
                <div class="domain">
                    <div class="domain-name">
                        {{ domain['name_' + lang] }}
                    </div>
                    <div class="domain-tag">
                        <span class="tag-items badge">{{ 'Remitted' | translate}}</span>
                        <span class="tag-items badge">{{ 'Clin. relevant' | translate}}</span>
                        <span class="tag-items badge">{{ 'Subclinical' | translate}}</span>
                    </div>
                </div>
                <ng-container *ngFor="let symptom of domain['symptoms']; let i = index;">
                    <div class="symptom" id="{{ symptom['id'] }}" *ngIf="!symptom['is_normal']">
                        <div class="col-xs-12 symptom-statement">
                            <div class="col-xs-6 name">
                                {{ i + 1 }}. {{ symptom['name_' + lang] }} {{ symptom['id'] }}
                            </div>
                            <div class="col-xs-6 rating">
                                <div class="rating__tag">
                                    <span class="rating__item none"></span>
                                    <span class="rating__tag_label"> {{ 'None' | translate }}</span>
                                </div>
                                <div class="rating__tag ">
                                    <span class="rating__item mild"></span>
                                    <span class="rating__tag_label"> {{ 'Mild'| translate }}</span>
                                </div>
                                <div class="rating__tag">
                                    <span class="rating__item moderate"></span>
                                    <span class="rating__tag_label"> {{ 'moderate' | translate }}</span>
                                </div>
                                <div class="rating__tag">
                                    <span class="rating__item severe"></span>
                                    <span class="rating__tag_label"> {{ 'severe' | translate }}</span>
                                </div>
                                <div class="rating__tag">
                                    <span class="rating__item anamnestic-only"></span>
                                    <span class="rating__tag_label"> {{ 'Anamnestic export' | translate }}</span>
                                </div>
                            </div>
                        </div>
                        <ng-container *ngIf="symptom['feelings'].length === 1">
                            <div class="col-xs-12 infor-statement">
                                <div class="col-xs-4">
                                    {{ 'Question' | translate }}
                                </div>
                                <div class="col-xs-8">
                                    {{ 'Definition' | translate }}
                                </div>
                            </div>
                            <div class="col-xs-12 infor-detail">
                                <div class="col-xs-4 question">
                                    <p [innerHTML]="symptom['feelings'][0]['question_' + lang] | safeHtml">
                                    </p>
                                </div>
                                <div class="col-xs-8" [innerHTML]="symptom['feelings'][0]['definition_' + lang] | safeHtml">
                                </div>
                            </div>
                        </ng-container>
                        <ng-container *ngIf="symptom['feelings'].length > 1">
                            <div class="col-xs-12 feeling-statement" *ngFor="let feeling of symptom['feelings']">
                                <div class="col-xs-6 name">
                                    {{ feeling['name_' + lang] }}
                                </div>
                                <div class="col-xs-6 rating">
                                    <div class="rating__tag">
                                        <span class="rating__item none"></span>
                                        <span class="rating__tag_label"> {{ 'None' | translate }}</span>
                                    </div>
                                    <div class="rating__tag">
                                        <span class="rating__item mild"></span>
                                        <span class="rating__tag_label"> {{ 'Mild'| translate }}</span>
                                    </div>
                                    <div class="rating__tag">
                                        <span class="rating__item moderate"></span>
                                        <span class="rating__tag_label"> {{ 'moderate' | translate }}</span>
                                    </div>
                                    <div class="rating__tag">
                                        <span class="rating__item severe"></span>
                                        <span class="rating__tag_label"> {{ 'severe' | translate }}</span>
                                    </div>
                                    <div class="rating__tag">
                                        <span class="rating__item anamnestic-only"></span>
                                        <span class="rating__tag_label"> {{ 'Anamnestic export' | translate }}</span>
                                    </div>
                                </div>
                            </div>
                            <div class="col-xs-12 infor-statement">
                                <div class="col-xs-4">
                                    {{ 'Question' | translate }}
                                </div>
                                <div class="col-xs-8">
                                    {{ 'Definition' | translate }}
                                </div>
                            </div>
                            <div class="col-xs-12 infor-detail">
                                <div class="col-xs-4 question">
                                    <p [innerHTML]="symptom['feelings'][0]['question_' + lang] | safeHtml">
                                    </p>
                                </div>
                                <div class="col-xs-8" [innerHTML]="symptom['feelings'][0]['definition_' + lang] | safeHtml">
                                </div>
                            </div>
                        </ng-container>
                    </div>
                </ng-container>
            </div>
        </ng-container>
    </div>
</div>
<dialog-component></dialog-component>
